import { formatSpeedToMbpsNumber } from '~/utils/format-speed'

import styles from './speed-details.module.css'

export const Speed = ({ title, body, subTitle, speed }) => (
  <>
    <span className={styles.speedTitle}>{title}</span>
    <p className={styles.speedBody}>{body}</p>
    <span className={styles.speedContainer}>
      <span className={styles.averageSpeed}>{subTitle}</span>
      <span className={styles.mbps}>{`${formatSpeedToMbpsNumber(speed)} Mbps`}</span>
    </span>
  </>
)

export const SpeedComparison = ({ icon, title, body }) => (
  <div className={styles.speedComparison}>
    <span className={styles.heading}>
      <span className={styles.iconBadgeGreen}>{icon()}</span>
      <span className={styles.text}>{title}</span>
    </span>
    <p className={styles.speedBody}>{body}</p>
  </div>
)

export const SmallPrint = ({ smallPrint }) => (
  <>
    {smallPrint.map((text) => (
      <p className={styles.smallPrint}>{text}</p>
    ))}
  </>
)
